<template>
  <div class="no_data">
    <img src="@/assets/no_data.png" alt="">
    {{ props.title }}
  </div>
</template>
<script setup>
const props = defineProps(['title'])
</script>
<style lang="less" scoped>
.no_data {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }

  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 24px;
  color: #90909A;
}
</style>
